import React, { useState, useEffect } from "react";
import "./Style.css";
import { FaTrophy } from "react-icons/fa";
import moment from "moment";
import { Apiurl } from "../../Pages/utils/page";
import { Modal, Pagination } from "react-bootstrap";
import { BsTruck } from "react-icons/bs";
import ReferralAddressModal from "../ReferralsProgram/ReferralAddressModal";
import WinneCheckoutModal from "./WinneCheckoutModal";
import { CiDeliveryTruck } from "react-icons/ci";
import { FaChevronDown } from "react-icons/fa";

const WinnerComponent = ({
  AllWinnerData,
  setStartDate,
  StartDate,
  setEndDate,
  EndDate,
  Filterdata,
  GetNewWinner,
  loginToken,
  loading,
  handleFilterAchievemnt,
  showAll,
  setShowAll,
  deliveryChargeModal,
  setDeliveryChargeModal,
  handleClose,
  setShow,
  show,
  addressList,
  setAddressList,
  fetchAddressList,
  selectedAddress,
  setSelectedAddress,
  clickedData,
  setClickedData,
  getProfileData,
  filterUserId,
  setFilteredUsedId,
  handleClaim,
  handleClicked,
  filterAllData,
  setFilterAllData,
  numberOfRecordSelected,
  totalRecord,
  setNumberofRecordSelected,
  pageNumber,
  handlePrevPage,
  handleNextPage,
  setPageNumber,
  deliveryCharge,
  combinePromoData,
  appliedPromoId,
  handleRemovePromo,
  handleApplyPromo,
  applyButton,
  totalValue,
  finalValue,
  showNewAddress,
  setShowNewAddress,
  pageNumbers,
  totalPages,
  setpageIndex,
  prevPage,
  pageArray,
  changePage,
  pageIndex,
  nextPage,
  showingFrom,showingTo
}) => {
 
  const [isMobileScreen, setIsMobileScreen] = useState(false);
  const [expandedPromoId, setExpandedPromoId] = useState(null);

  const toggleDetails = (id) => {
    setExpandedPromoId(expandedPromoId === id ? null : id);
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobileScreen(window.innerWidth >= 320 && window.innerWidth <= 767);
    };

    // Initial check
    handleResize();

    // Add event listener
    window.addEventListener("resize", handleResize);

    // Clean up event listener on unmount
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      <div className="banner_section" style={{ flex: "1" }}>
        <div className="winner_bg">
          <div className="container">
            <div className="winner_section">
              <h3>Congratulations</h3>
              <h2>WINNERS!</h2>
              <div className="winner_section-icons">
                <FaTrophy className="winning_trophy" />
              </div>
              <div className="winner_section-Filters">
                {loginToken ? (
                  <>
                    <div className="winner_section-filter-inner-containerfor-start-date">
                      <label htmlFor="">Start Date</label>
                      <input
                        type="date"
                        value={StartDate}
                        onChange={(e) => setStartDate(e.target.value)}
                        name=""
                        id=""
                      />
                    </div>
                    <div
                      className={
                        !StartDate
                          ? "Winner-section-end-date"
                          : "winner_section-filter-inner-container"
                      }
                    >
                      <label htmlFor="">End Date</label>
                      <input
                        type="date"
                        value={EndDate}
                        onChange={(e) => setEndDate(e.target.value)}
                        name=""
                        id=""
                        disabled={!StartDate}
                      />
                    </div>
                    {!showAll && StartDate && EndDate ? (
                      <div className="OwnAchievements-container">
                        <button
                          className="Own-Achievements-button"
                          onClick={() => {
                            GetNewWinner("All");
                            setStartDate("");
                            setEndDate("");
                          }}
                        >
                          Clear Filter
                        </button>
                      </div>
                    ) : (
                      <div className="OwnAchievements-container">
                        <button
                          className="Own-Achievements-button"
                          onClick={handleFilterAchievemnt}
                        >
                          My Winnings
                        </button>
                      </div>
                    )}
                  </>
                ) : null}

                {showAll ? (
                  <div className="AllWinners-container">
                    <button
                      onClick={() => {
                        setShowAll(false);
                        setFilterAllData();
                        GetNewWinner("All");
                        setStartDate("");
                        setEndDate("");
                      }}
                      className="Own-Achievements-button"
                    >
                      All Winners
                    </button>
                  </div>
                ) : null}
              </div>
              {/* Winner List Section */}
              <div className="col-lg-12 ml-auto mr-auto">
                {filterAllData?.length && showAll ? (
                  <>
                    {filterAllData?.map((item, index) => {
                      const User = item?.UserImageURL?.split('"');
                      const UserUrl = `${Apiurl()}/${User?.[1]}`;
                      const Product = item?.ProductImageURL?.split('"');
                      const productUrl = `${Apiurl()}/${Product?.[3]}`;

                      return (
                        <div className="row" key={index}>
                          <div className="col-lg-12">
                            <div className="winner_main_border_wraper">
                              <div className="winner_date_display">
                                <p>
                                  {moment(item?.Date).format("MMM Do YYYY")}
                                </p>
                              </div>
                              <div className="winner_inner_border_section">
                                <div className="row">
                                  {isMobileScreen ? (
                                    <>
                                      <div className="product_name_display-mb">
                                        <div className="wiiner_reward_name">
                                          <p>{item?.ProductName}</p>
                                        </div>
                                      </div>
                                      <div className="col-lg-3 col-sm-3 col-6">
                                        <img
                                          src={productUrl}
                                          className="winner_product_img"
                                          alt="Product"
                                          onError={(e) => {
                                            e.target.onerror = null;
                                            e.target.src =
                                              "/Images/no-product-img-700.jpg";
                                          }}
                                        />
                                      </div>
                                    </>
                                  ) : (
                                    <div className="col-lg-3 col-sm-3 col-6">
                                      <div className="product_name_display-web">
                                        <div className="wiiner_reward_name">
                                          <p>{item?.ProductName}</p>
                                        </div>
                                      </div>
                                      <img
                                        src={productUrl}
                                        className="winner_product_img"
                                        alt="Product"
                                        onError={(e) => {
                                          e.target.onerror = null;
                                          e.target.src =
                                            "/Images/no-product-img-700.jpg";
                                        }}
                                      />
                                    </div>
                                  )}
                                  <div className="col-lg-9 col-sm-9 col-6 winner_sec_lf_pd_0">
                                    <div className="wiiner_list_new_wraper">
                                      <div className="winner_section_scroll_01 winner-user_scroll">
                                        <div className="winnerz_profile_new">
                                          <img
                                            className="winnerz_profie_image"
                                            src={UserUrl}
                                            alt="User"
                                            onError={(e) => {
                                              e.target.onerror = null; // Prevent infinite loop
                                              e.target.src =
                                                "/Images/unisexImage.jpeg";
                                            }}
                                          />
                                          <div className="winner_name_display">
                                            <p>{item?.Username}</p>
                                          </div>
                                        </div>
                                      </div>
                                      {getProfileData
                                        ? item?.Email ===
                                            getProfileData?.Email && (
                                            <>
                                              {item?.IsClaimed ? (
                                                <button className="btn btn-success">
                                                  Claimed
                                                </button>
                                              ) : (
                                                <button
                                                  className="btn btn-success"
                                                  onClick={() => {
                                                    handleClicked(item);
                                                    setDeliveryChargeModal(
                                                      true
                                                    );
                                                  }}
                                                >
                                                  Claim
                                                </button>
                                              )}
                                            </>
                                          )
                                        : null}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </>
                ) : showAll ? (
                  <h4>No Winners Yet</h4>
                ) : (
                  <>
                    {AllWinnerData?.length > 0 ? (
                      AllWinnerData?.map((item, index) => {
                        // const Product =
                        //   item?.Product?.ProductImageURL?.[0]?.Images;
                        // const productUrl = `${Apiurl()}/${Product}`;

                        const imagesArray = JSON.parse(
                          item?.Product?.ProductImageURL
                        );

                        const defaultImage = imagesArray.find(
                          (img) => img.Default
                        );

                        const imageUrl = defaultImage
                          ? `${Apiurl()}/${defaultImage.Images}`
                          : "";

                        return (
                          <div className="row" key={index}>
                            <div className="col-lg-12">
                              <div className="winner_main_border_wraper">
                                <div className="winner_date_display">
                                  <p>
                                    {moment(item.Product?.Date).format(
                                      "MMM Do YYYY"
                                    )}
                                  </p>
                                </div>
                                <div className="winner_inner_border_section">
                                  <div className="row">
                                    {isMobileScreen ? (
                                      <>
                                        <div className="product_name_display-mb">
                                          <div className="wiiner_reward_name">
                                            <p>{item.Product?.ProductName}</p>
                                          </div>
                                        </div>
                                        <div className="col-lg-3 col-sm-3 col-6">
                                          <img
                                            src={imageUrl}
                                            className="winner_product_img"
                                            alt="Product"
                                            onError={(e) => {
                                              e.target.onerror = null;
                                              e.target.src =
                                                "/Images/no-product-img-700.jpg";
                                            }}
                                          />
                                        </div>
                                      </>
                                    ) : (
                                      <div className="col-lg-3 col-sm-3 col-6">
                                        <div className="product_name_display-web">
                                          <div className="wiiner_reward_name">
                                            <p>{item.Product?.ProductName}</p>
                                          </div>
                                        </div>
                                        <img
                                          src={imageUrl}
                                          className="winner_product_img"
                                          alt="Product"
                                          onError={(e) => {
                                            e.target.onerror = null;
                                            e.target.src =
                                              "/Images/no-product-img-700.jpg";
                                          }}
                                        />
                                        Brand Name : {item?.Product?.BrandName}
                                      </div>
                                    )}
                                    <div className="col-lg-9 col-sm-9 col-6 winner_sec_lf_pd_0">
                                      <div className="wiiner_list_new_wraper">
                                        <div className="winner_section_scroll_01 winner-user_scroll">
                                          {item?.Winners?.map(
                                            (user, userIndex) => {
                                              const User =
                                                user?.UserImageURL?.split('"');
                                              const UserUrl = `${Apiurl()}/${
                                                User?.[1]
                                              }`;

                                              return (
                                                <div
                                                  className="winnerz_profile_new"
                                                  key={`${index}-${userIndex}`}
                                                >
                                                  <img
                                                    className="winnerz_profie_image"
                                                    src={
                                                      UserUrl.includes(
                                                        "undefined"
                                                      )
                                                        ? "/Images/unisexImage.jpeg"
                                                        : UserUrl
                                                    }
                                                    onError={(e) => {
                                                      e.target.onerror = null; // Prevent infinite loop
                                                      e.target.src =
                                                        "/Images/unisexImage.jpeg";
                                                    }}
                                                  />
                                                  <div className="winner_name_display">
                                                    <p>{user.Username}</p>
                                                  </div>
                                                </div>
                                              );
                                            }
                                          )}
                                        </div>
                                        {getProfileData
                                          ? item?.Winners?.find(
                                              (i) =>
                                                i?.Email ===
                                                getProfileData?.Email
                                            ) && (
                                              <>
                                                {item?.Winners?.find(
                                                  (i) =>
                                                    i?.Email ===
                                                    getProfileData?.Email
                                                ).IsClaimed ? (
                                                  <button className="btn btn-success">
                                                    Claimed
                                                  </button>
                                                ) : (
                                                  <button
                                                    className="btn btn-success"
                                                    onClick={() => {
                                                      handleClicked(item);
                                                      setDeliveryChargeModal(
                                                        true
                                                      );
                                                    }}
                                                  >
                                                    Claim
                                                  </button>
                                                )}
                                              </>
                                            )
                                          : null}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      })
                    ) : (
                      <h4>No Winners Yet</h4>
                    )}
                    {/* {Object.values(AllWinnerData)?.length > 0 ? (
                      Object.values(AllWinnerData)
                        .sort((a, b) => {
                          const dateComparison =
                            new Date(b.Date) - new Date(a.Date);
                          return (
                            dateComparison ||
                            a.ProductName.localeCompare(b.ProductName)
                          );
                        })
                        .map((item, index) => {
                          const Product = item?.ProductImageURL?.[0]?.Images;
                          const productUrl = `${Apiurl()}/${Product}`;

                          return (
                            <div className="row" key={index}>
                              <div className="col-lg-12">
                                <div className="winner_main_border_wraper">
                                  <div className="winner_date_display">
                                    <p>
                                      {moment(item.Date).format("MM/DD/YYYY")}
                                    </p>
                                  </div>
                                  <div className="winner_inner_border_section">
                                    <div className="row">
                                      {isMobileScreen ? (
                                        <>
                                          <div className="product_name_display-mb">
                                            <div className="wiiner_reward_name">
                                              <p>{item.ProductName}</p>
                                            </div>
                                          </div>
                                          <div className="col-lg-3 col-sm-3 col-6">
                                            <img
                                              src={productUrl}
                                              className="winner_product_img"
                                              alt="Product"
                                              onError={(e) => {
                                                e.target.onerror = null;
                                                e.target.src =
                                                  "/Images/no-product-img-700.jpg";
                                              }}
                                            />
                                          </div>
                                        </>
                                      ) : (
                                        <div className="col-lg-3 col-sm-3 col-6">
                                          <div className="product_name_display-web">
                                            <div className="wiiner_reward_name">
                                              <p>{item.ProductName}</p>
                                            </div>
                                          </div>
                                          <img
                                            src={productUrl}
                                            className="winner_product_img"
                                            alt="Product"
                                            onError={(e) => {
                                              e.target.onerror = null;
                                              e.target.src =
                                                "/Images/no-product-img-700.jpg";
                                            }}
                                          />
                                        </div>
                                      )}
                                      <div className="col-lg-9 col-sm-9 col-6 winner_sec_lf_pd_0">
                                        <div className="wiiner_list_new_wraper">
                                          <div className="winner_section_scroll_01 winner-user_scroll">
                                            {item?.Users?.map(
                                              (user, userIndex) => {
                                                const User =
                                                  user?.UserImageURL?.split(
                                                    '"'
                                                  );
                                                const UserUrl = `${Apiurl()}/${
                                                  User?.[1]
                                                }`;

                                                return (
                                                  <div
                                                    className="winnerz_profile_new"
                                                    key={`${index}-${userIndex}`}
                                                  >
                                                    <img
                                                      className="winnerz_profie_image"
                                                      src={
                                                        UserUrl.includes(
                                                          "undefined"
                                                        )
                                                          ? "/Images/unisexImage.jpeg"
                                                          : UserUrl
                                                      }
                                                      onError={(e) => {
                                                        e.target.onerror = null; // Prevent infinite loop
                                                        e.target.src =
                                                          "/Images/unisexImage.jpeg";
                                                      }}
                                                    />
                                                    <div className="winner_name_display">
                                                      <p>{user.Username}</p>
                                                    </div>
                                                  </div>
                                                );
                                              }
                                            )}
                                          </div>
                                          {getProfileData
                                            ? item?.Users?.find(
                                                (i) =>
                                                  i?.Email ===
                                                  getProfileData?.Email
                                              ) && (
                                                <>
                                                  {item?.Users?.find(
                                                    (i) =>
                                                      i?.Email ===
                                                      getProfileData?.Email
                                                  ).IsClaimed ? (
                                                    <button className="btn btn-success">
                                                      Claimed
                                                    </button>
                                                  ) : (
                                                    <button
                                                      className="btn btn-success"
                                                      onClick={() => {
                                                        handleClicked(item);
                                                        setDeliveryChargeModal(
                                                          true
                                                        );
                                                      }}
                                                    >
                                                      Claim
                                                    </button>
                                                  )}
                                                </>
                                              )
                                            : null}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        })
                    ) : (
                      <h4>No Winners Yet</h4>
                    )} */}
                  </>
                )}
              </div>
              {!showAll ? (
                <>
                  {filterAllData?.length || AllWinnerData.length > 0 ? (
                    <div className="row">
                      <div className="col-lg-4">
                        <div className="pagination-summary">
                          {filterAllData?.length || showAll ? (
                            <span>
                              Showing {showingFrom?.toLocaleString()} -{" "}
                              {showingTo?.toLocaleString()} from{" "}
                              {filterAllData?.length || totalRecord} Records
                              {/* Displaying{" "}
                              {Math.min(
                                pageNumber * (numberOfRecordSelected || 10) + 1,
                                totalRecord
                              )}
                              -
                              {Math.min(
                                (pageNumber + 1) *
                                  (numberOfRecordSelected || 10),
                                totalRecord
                              )}
                              of {filterAllData?.length || totalRecord} records */}
                            </span>
                          ) : (
                            <span>
                              Showing {showingFrom?.toLocaleString()} -{" "}
                              {showingTo?.toLocaleString()} from {totalRecord}{" "}
                              Records
                              {/* Displaying{" "}
                              {Math.min(
                                pageNumber * (numberOfRecordSelected || 10) + 1,
                                totalRecord
                              )}
                              -
                              {Math.min(
                                (pageNumber + 1) *
                                  (numberOfRecordSelected || 10),
                                totalRecord
                              )}
                              of {totalRecord} records */}
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <div className="pagination-controls">
                          <Pagination className="mt-1">
                            <Pagination.First onClick={() => {setpageIndex(1);}} />
                            <Pagination.Prev onClick={prevPage} />
                            {pageArray?.map((item, i) => (
                              <Pagination.Item
                                onClick={() => {
                                  changePage(item);
                                }}
                                active={pageIndex === item}
                                key={i}
                              >
                                {item}
                              </Pagination.Item>
                            ))}
                            <Pagination.Next onClick={nextPage} />
                            <Pagination.Last
                              onClick={() => setpageIndex(totalPages)}
                            />
                          </Pagination>
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <div className="records-per-page pull-right">
                          <label for="recordsPerPage">Records per page:</label>
                          <select
                            id="recordsPerPage"
                            className="form-select"
                            onChange={(e) => {
                              setPageNumber(0);
                              setpageIndex(1)
                              setNumberofRecordSelected(e?.target?.value);
                              GetNewWinner("", "i", e?.target?.value);
                            }}
                          >
                            <option value="10">10</option>
                            <option value="15">15</option>
                            <option value="25">25</option>
                            <option value="50">50</option>
                            <option value="100">100</option>
                          </select>
                        </div>
                      </div>
                    </div>
                  ) : null}
                </>
              ) : null}
            </div>
          </div>
        </div>
      </div>
      <Modal
        backdrop="static"
        className="claim_firstModal"
        show={deliveryChargeModal}
        onHide={handleClose}
        animation={false}
      >
        <Modal.Header closeButton>
          <Modal.Title className="claim-Product-main-heading">
            Claim Product
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="claim-Product-container  align-items-center mb-2">
            <div className="Image-forModal-popup">
              <h5>
                <CiDeliveryTruck />
                Delivery Charges{" "}
                <span>₹ {clickedData?.DeliveryCharges || 0}</span>
              </h5>
            </div>
            <div className="claim-Product-Inner-container ml-3"></div>
          </div>
          {clickedData?.DeliveryCharges > 0 ? (
            <>
              {combinePromoData?.length ? (
                <div className="claim-Product-PromoCode-Container mb-4">
                  <h3>Promo Codes</h3>
                  {combinePromoData?.map((item) => {
                    return (
                      <div className="promo-code-item  justify-content-between align-items-center mb-2">
                        <h4>
                          {item?.PromoCode}
                          <button
                            type="button"
                            className="promo_view_dtal_btn btn-sm relaunch-btn btn-info"
                            onClick={() => toggleDetails(item?.Id)}
                          >
                            View Details{" "}
                            <FaChevronDown className="arrow_down_pro" />
                          </button>
                        </h4>
                        {expandedPromoId === item?.Id && (
                          <div className="promo-code-details">
                            <p>{item?.Description}</p>
                            <p>
                              Validity:{" "}
                              {moment(item?.ToDate).format("YYYY-MM-DD")}
                            </p>
                          </div>
                        )}

                        {/* <div className="promo-code-details">
                             <p>{item?.Description}</p>
                             <p>Validity: {moment(item?.ToDate).format()}</p>
                           </div> */}
                        {appliedPromoId === item?.Id ? (
                          <button
                            type="button"
                            className="apply_btn btn-sm "
                            onClick={() => handleRemovePromo()}
                          >
                            Remove
                          </button>
                        ) : (
                          <button
                            type="button"
                            className="apply_btn btn-sm "
                            onClick={() => handleApplyPromo(item)}
                          >
                            Apply
                          </button>
                        )}
                      </div>
                    );
                  })}
                </div>
              ) : null}
            </>
          ) : null}

          <div className="claim-Product-container mb-2 mt-2">
            <h5>
              Delivery charge <span>₹ {clickedData?.DeliveryCharges || 0}</span>
            </h5>
          </div>
          <hr className="Modal_hr-line" />
          <div className="Modal-total-section">
            <h5>
              Total
              <span>₹ {applyButton ? finalValue : totalValue || 0}</span>
            </h5>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="CheckoutButton"
            onClick={() => {
              setShow(true);
              setDeliveryChargeModal(false);
            }}
          >
            Checkout
          </button>
        </Modal.Footer>
      </Modal>
      <WinneCheckoutModal
        show={show}
        setShow={setShow}
        addressList={addressList}
        setAddressList={setAddressList}
        fetchAddressList={fetchAddressList}
        setSelectedAddress={setSelectedAddress}
        selectedAddress={selectedAddress}
        handleClaim={handleClaim}
        setShowNewAddress={setShowNewAddress}
        showNewAddress={showNewAddress}
      />
    </>
  );
};
export default WinnerComponent;
